import { formatDate, getToday } from "../utils/date";

export const getDefaultDateRange = (): [string, string] => {
  return [formatDate(new Date(2000, 0, 1)), formatDate(getToday().to)];
};
